import RightArrowIconWhite from "../../../assets/icons/header-icons/right-arrow-white.svg";
import {
  handleDemoLogin,
  loginSuccess,
  useAppDispatch,
  useAppSelector,
  SIGN_UP_ROUTE,
  REGISTER,
  LOGIN_ROUTE,
  HOME_ROUTE,
  getSapToken,
  showToast,
  ACCEPT_TERMS_ROUTE,
  RESET_PASSWORD_ROUTE,
  useLogin,
} from "@hypexone/uicore";
import HeaderButtonComponent from "./HeaderButtonComponent";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import LoginPageBtn from "../login-page-btn/LoginPageBtn";
import handIcon from "../../../assets/images/hand-right.png";
import instagramIcon from "../../../assets/icons/instagram-icon.svg";
import telegramIcon from "../../../assets/icons/telegram-icon.svg";
// import whatsappIcon from "../../../assets/icons/user-menu-icons/whatsapp-icon-green.svg";
import { isDesktop, isMobile } from "react-device-detect";
import SocialAuth from "../../pages/social-auth/SocialAuth";
import { useSignUpModal } from "../../context/SignUpModalContext";
import { useResendEmailModal } from "../../context/ResendEmailModalContext";
import { useForgotPasswordModal } from "../../context/ForgotPasswordModalContext";

type LoginVariant = "header" | "mobilePage" | "standalone";

const supportEmailId = "laserwin247@gmail.com";

// --- Login2FAContent (shared 2FA + Reset 2FA forms) ---
interface Login2FAContentProps {
  showReset2FA: boolean;
  setShowReset2FA: (v: boolean) => void;
  twoFactorCode: string;
  setTwoFactorCode: (v: string) => void;
  handle2FASubmit: (e: React.FormEvent) => void;
  handle2FABack: () => void;
  is2FALoading: boolean;
  identifierValue: string;
  setIdentifierValue: (v: string) => void;
  resetIdentifierType: "PHONE_NUMBER" | "EMAIL";
  setResetIdentifierType: (v: "PHONE_NUMBER" | "EMAIL") => void;
  resetOtp: string;
  setResetOtp: (v: string) => void;
  resetOtpTimer: number | undefined;
  resetOtpEnterFields: boolean;
  resetLoading: boolean;
  isResetting: boolean;
  resetErrorMsg: string;
  generateResetOtp: () => void;
  resetTwoFactor: () => void;
  handleReset2FABack: () => void;
  langData: Record<string, string> | undefined;
  isInline?: boolean;
}

const formatOTPInput = (value: string) => value.replace(/\D/g, "").slice(0, 6);

const Login2FAContent: React.FC<Login2FAContentProps> = ({
  showReset2FA,
  setShowReset2FA,
  twoFactorCode,
  setTwoFactorCode,
  handle2FASubmit,
  handle2FABack,
  is2FALoading,
  identifierValue,
  setIdentifierValue,
  resetIdentifierType,
  setResetIdentifierType,
  resetOtp,
  setResetOtp,
  resetOtpTimer,
  resetOtpEnterFields,
  resetLoading,
  isResetting,
  resetErrorMsg,
  generateResetOtp,
  resetTwoFactor,
  handleReset2FABack,
  langData,
  isInline = false,
}) => {
  const textClass = isInline ? "text-black4" : "text-white";
  const inputClass = isInline
    ? "w-full px-3 py-2 bg-white border border-gray-300 rounded-lg text-black"
    : "w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-black";
  const btnSecondary = isInline
    ? "flex-1 bg-gray-500 text-white py-2 px-4 rounded-lg hover:bg-gray-600"
    : "flex-1 bg-gray-600 text-white py-2 px-4 rounded-md hover:bg-gray-700";
  const btnPrimary = isInline
    ? "flex-1 bg-header-gradient text-goldenYellow py-2 px-4 rounded-lg font-bold disabled:opacity-50"
    : "flex-1 bg-goldenYellow text-black py-2 px-4 rounded-md font-semibold hover:bg-yellow-500 disabled:opacity-50";
  const { domainConfig } = useAppSelector((state) => state.common);

  if (showReset2FA) {
    return (
      <form onSubmit={(e) => e.preventDefault()} className="w-full">
        <div className="text-center mb-4">
          <h3 className={`text-lg font-semibold ${textClass} mb-1`}>
            {langData?.["reset_two_factor_auth"] ?? "Reset Two-Factor Authentication"}
          </h3>
          <p className={`text-sm ${isInline ? "text-black3" : "text-gray-300"}`}>
            {langData?.["reset_2fa_description"] ??
              "Enter your phone number or email to reset 2FA. You will receive an OTP to verify."}
          </p>
        </div>
        {!resetOtpEnterFields ? (
          <>
            <div className="flex gap-2 mb-3">
              <select
                className={`${inputClass} min-w-fit max-w-fit shrink-0`}
                value={resetIdentifierType}
                onChange={(e) =>
                  setResetIdentifierType(e.target.value === "EMAIL" ? "EMAIL" : "PHONE_NUMBER")
                }
              >
                <option value="PHONE_NUMBER">+91</option>
                <option value="EMAIL">{langData?.["email"] ?? "Email"}</option>
              </select>
              <input
                type="text"
                className={`${inputClass}`}
                value={identifierValue}
                onChange={(e) => setIdentifierValue(e.target.value)}
                placeholder={
                  resetIdentifierType === "EMAIL"
                    ? langData?.["enter_email_txt"] ?? "Enter Email"
                    : langData?.["enter_whatsapp_no"] ?? "Enter Phone Number"
                }
              />
            </div>
            {resetErrorMsg && (
              <div className="text-red-500 text-sm text-center mb-2">{resetErrorMsg}</div>
            )}
            <div className="flex gap-2">
              <button type="button" onClick={handleReset2FABack} className={btnSecondary}>
                {langData?.["back_to_2fa"] ?? "Back to 2FA"}
              </button>
              <button
                type="button"
                onClick={generateResetOtp}
                disabled={!identifierValue.trim() || resetLoading}
                className={`${btnPrimary} disabled:opacity-50`}
              >
                {resetLoading ? (langData?.["sending"] ?? "Sending...") : langData?.["send_otp"] ?? "Send OTP"}
              </button>
            </div>
          </>
        ) : (
          <>
            {resetOtpTimer != null && (
              <div className={`text-center mb-2 text-sm ${isInline ? "text-black4" : "text-gray-300"}`}>
                {langData?.["otp_timer"] ?? "Resend OTP in"} {resetOtpTimer}s
              </div>
            )}
            <div className="mb-3">
              <input
                type="tel"
                inputMode="numeric"
                className={inputClass}
                value={resetOtp}
                onChange={(e) => setResetOtp(formatOTPInput(e.target.value))}
                placeholder={langData?.["enter_otp_txt"] ?? "Enter OTP"}
                maxLength={6}
              />
            </div>
            {resetErrorMsg && (
              <div className="text-red-500 text-sm text-center mb-2">{resetErrorMsg}</div>
            )}
            <div className="flex gap-2">
              <button type="button" onClick={handleReset2FABack} className={btnSecondary}>
                {langData?.["back_to_2fa"] ?? "Back to 2FA"}
              </button>
              <button
                type="button"
                onClick={resetTwoFactor}
                disabled={resetOtp.length !== 6 || isResetting}
                className={`${btnPrimary} disabled:opacity-50`}
              >
                {isResetting ? (langData?.["resetting"] ?? "Resetting...") : langData?.["verify_and_reset_2fa"] ?? "Verify & Reset 2FA"}
              </button>
            </div>
          </>
        )}
      </form>
    );
  }

  return (
    <form onSubmit={handle2FASubmit} className="w-full">
      <div className="text-center mb-4">
        <h3 className={`text-lg font-semibold ${textClass} mb-1`}>
          {langData?.["two_factor_auth"] ?? "Two-Factor Authentication"}
        </h3>
        <p className={`text-sm ${isInline ? "text-black3" : "text-gray-300"}`}>
          {langData?.["enter_6_digit_code"] ?? "Enter the 6-digit code from your authenticator app"}
        </p>
      </div>
      <div className="mb-4">
        <label className={`block text-sm font-normal mb-1 ${textClass}`}>
          {langData?.["authentication_code"] ?? "Authentication Code"}
        </label>
        <input
          type="text"
          inputMode="numeric"
          value={twoFactorCode}
          onChange={(e) => setTwoFactorCode(formatOTPInput(e.target.value))}
          placeholder="123456"
          className={`${inputClass} text-center text-lg tracking-widest`}
          maxLength={6}
          autoComplete="off"
        />
      </div>
      <div className="flex gap-2">
        <button type="button" onClick={handle2FABack} className={btnSecondary}>
          {langData?.["back_to_login"] ?? "Back to Login"}
        </button>
        <button
          type="submit"
          disabled={is2FALoading || twoFactorCode.length !== 6}
          className={`${btnPrimary} disabled:opacity-50`}
        >
          {is2FALoading ? (langData?.["verifying"] ?? "Verifying...") : langData?.["verify_and_login"] ?? "Verify & Login"}
        </button>
      </div>
      <div className="flex justify-center mt-3">
        <button
          type="button"
          onClick={() => setShowReset2FA(true)}
          className={`text-sm hover:underline ${isInline ? "text-red-600" : "text-red-400"}`}
        >
          {langData?.["reset_two_factor_auth"] ?? "Reset Two-Factor Authentication"}
        </button>
      </div>
    </form>
  );
};

// --- LoginFormFields ---
interface LoginFormFieldsProps {
  variant: LoginVariant;
  formValues: { username: string; password: string };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  validationCode: string;
  validationInput: string;
  setValidationInput: (v: string) => void;
  handleEnterKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleForgotPassClick: () => void;
  handleResendEmailClick: () => void;
  handleSignUpClick: () => void;
  langData: Record<string, string> | undefined;
  domainConfig: { b2cEnabled?: boolean };
  signup?: boolean;
  oauth_enabled?: boolean;
}

const LoginFormFields: React.FC<LoginFormFieldsProps> = ({
  variant,
  formValues,
  handleChange,
  validationCode,
  validationInput,
  setValidationInput,
  handleEnterKeyPress,
  handleForgotPassClick,
  handleResendEmailClick,
  handleSignUpClick,
  langData,
  domainConfig,
}) => {
  const isMobilePage = variant === "mobilePage";
  const textClass = isMobilePage ? "text-black4" : "text-white";

  const isHeader = variant === "header";
  const headerInputClass =
    "h-7 w-[120px] rounded-md border-0 bg-white px-2 text-[12px] text-black outline-none placeholder:text-[12px] placeholder:text-neutral-400 shadow-none";

  return (
    <div
      className={`relative ${
        variant === "mobilePage"
          ? "flex w-full flex-col items-center gap-3"
          : isHeader
            ? "flex items-center gap-1.5"
            : "flex items-center gap-2"
      }`}
    >
      <input
        name="username"
        placeholder="Username"
        className={
          isMobilePage
            ? "login-input h-12 w-full rounded-lg border border-neutral-200 bg-[#fdf3d2] px-4 text-[17px] shadow-sm outline-none placeholder:text-[17px] placeholder:text-neutral-500"
            : isHeader
              ? headerInputClass
              : "h-[25px] rounded-[5px] px-2 text-sm outline-none md:w-[130px] md:placeholder-gray-400 placeholder:text-sm"
        }
        value={formValues.username}
        onChange={handleChange}
        onKeyDown={handleEnterKeyPress}
        autoComplete="username"
      />
      <input
        name="password"
        type="password"
        placeholder="Password"
        className={
          isMobilePage
            ? "login-input h-12 w-full rounded-lg border border-neutral-200 bg-[#fdf3d2] px-4 text-[17px] shadow-sm outline-none placeholder:text-[17px] placeholder:text-neutral-500"
            : isHeader
              ? headerInputClass
              : "h-[25px] rounded-[5px] px-2 text-sm outline-none md:w-[130px] md:placeholder-gray-400 placeholder:text-sm"
        }
        value={formValues.password}
        onChange={handleChange}
        onKeyDown={handleEnterKeyPress}
        autoComplete="current-password"
      />
      <div
        className={
          isMobilePage
            ? "flex h-12 w-full items-center gap-2 rounded-lg border border-neutral-200 bg-[#fdf3d2] px-4 shadow-sm"
            : isHeader
              ? "flex h-7 w-[120px] items-center gap-1.5 rounded-md bg-white px-2"
              : "flex h-[25px] items-center gap-2 rounded-[5px] bg-white px-2 md:w-[130px]"
        }
      >
        <input
          id="login-validation-input"
          type="text"
          inputMode="numeric"
          placeholder={
            // The header input is only 120px wide — the longer label truncates there
            langData?.["validation"] ??
            (isMobilePage ? "Validation Code" : "Validation")
          }
          className={`min-w-0 flex-1 border-none bg-transparent text-black outline-none placeholder:text-neutral-400 ${
            isMobilePage
              ? "text-[17px] placeholder:text-[17px]"
              : "text-[12px] placeholder:text-[12px]"
          }`}
          value={validationInput}
          onChange={(e) => setValidationInput(e.target.value)}
          onKeyDown={handleEnterKeyPress}
          aria-label={langData?.["validation"] ?? "Validation code"}
          autoComplete="off"
        />
        <span
          className={
            isHeader
              ? "shrink-0 text-[12px] font-bold text-black"
              : isMobilePage
                ? "shrink-0 text-[17px] font-bold text-black"
                : "shrink-0 text-sm font-bold text-black max-md:text-base"
          }
        >
          {validationCode}
        </span>
      </div>
      <div
        className={
          isMobilePage
            ? "flex w-full items-center justify-between gap-2 py-0.5 text-[10px] text-black4 underline"
            : isHeader
              ? "ml-0.5 flex flex-col items-start justify-center gap-0.5 text-nowrap leading-tight"
              : "mt-1 flex w-full flex-col justify-end text-nowrap text-[10px]"
        }
      >
        {/* {domainConfig.b2cEnabled && isHeader && (
          <button
            type="button"
            onClick={handleSignUpClick}
            className="w-fit cursor-pointer border-0 bg-transparent p-0 text-left text-[10px] font-semibold text-[#ffb600] underline underline-offset-2 transition-opacity hover:opacity-80"
          >
            {langData?.["sign_up"]}
          </button>
        )} */}
        {/* {domainConfig.b2cEnabled && (
          <button
            type="button"
            onClick={handleForgotPassClick}
            className={`w-fit cursor-pointer border-0 bg-transparent p-0 text-left transition-opacity hover:opacity-80 ${
              isHeader ? "text-[9px] text-white/85" : `text-[10px] ${textClass}`
            }`}
          >
            {langData?.["forgot_password"]}?
          </button>
        )} */}
        {/* {domainConfig.b2cEnabled && (
          <button
            type="button"
            onClick={handleResendEmailClick}
            className={`w-fit cursor-pointer border-0 bg-transparent p-0 text-left transition-opacity hover:opacity-80 ${
              isHeader ? "text-[9px] text-white/70" : `text-[10px] ${textClass}`
            }`}
          >
            {langData?.["resend_email"] || "Resend Verification email"}?
          </button>
        )} */}
      </div>
    </div>
  );
};

// --- LoginActionButtons ---
interface LoginActionButtonsProps {
  variant: LoginVariant;
  handleLogin: () => void;
  onDemoLogin: () => void;
  handleSignUpClick: () => void;
  loading: boolean;
  demoLoginLoader: boolean;
  setDemoLoginLoader: (v: boolean) => void;
  langData: Record<string, string> | undefined;
  domainConfig: { demoUser?: boolean; signup?: boolean; oauth_enabled?: boolean };
}

const LoginActionButtons: React.FC<LoginActionButtonsProps> = ({
  variant,
  handleLogin,
  onDemoLogin,
  handleSignUpClick,
  loading,
  demoLoginLoader,
  setDemoLoginLoader,
  langData,
  domainConfig,
}) => {
  const isMobilePage = variant === "mobilePage";
  const isHeader = variant === "header";
  const loginBtnClass = isMobilePage
    ? "w-full h-12 rounded-lg !bg-header-gradient px-3 text-[17px] font-bold !text-goldenYellow shadow-[0_6px_16px_rgba(0,0,0,0.18)] transition-all duration-200 hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-60"
    : undefined;
  // Demo matches Login exactly, only the label differs
  const demoBtnClass = loginBtnClass;

  const handleDemoClick = () => {
    setDemoLoginLoader(true);
    onDemoLogin();
  };

  if (isHeader) {
    return (
      <div className="ml-1 flex items-center gap-1.5">
        <div className="flex items-center gap-1.5">
          <HeaderButtonComponent
            rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
            customCSS="h-7 !rounded-md !px-3 !py-0"
            customButtonHeight="h-7"
            customButtonRadius="rounded-md"
            onClick={handleLogin}
            isRedButton
            buttonText={"Login"}
            loading={loading}
          />
          {/* Desktop shows Signup here; smaller screens keep the Demo login */}
          {isDesktop
            ? domainConfig.signup && (
                <HeaderButtonComponent
                  rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
                  customCSS="h-7 !rounded-md !px-3 !py-0 !bg-button-gradient"
                  customButtonHeight="h-7"
                  customButtonRadius="rounded-md"
                  onClick={handleSignUpClick}
                  buttonText={langData?.["sign_up"] || "Signup"}
                />
              )
            : domainConfig.demoUser && (
                <HeaderButtonComponent
                  rightIcon={{ src: RightArrowIconWhite, alt: "right-arrow" }}
                  customCSS="h-7 !rounded-md !px-3 !py-0"
                  customButtonHeight="h-7"
                  customButtonRadius="rounded-md"
                  onClick={handleDemoClick}
                  isRedButton
                  buttonText={langData?.["demo_login"] || "Demo Login"}
                  loading={demoLoginLoader}
                />
              )}
        </div>
        {/* {domainConfig?.oauth_enabled && (
          <div className="flex items-center gap-1">
            <span className="text-[10px] font-medium text-white/70">or</span>
            <SocialAuth variant="header" />
          </div>
        )} */}
      </div>
    );
  }

  return (
    <div className={`flex w-full flex-col ${isMobilePage ? "gap-1.5" : "gap-2"}`}>
      <LoginPageBtn
        loading={loading}
        onClick={handleLogin}
        label={"Login"}
        className={loginBtnClass}
      />
      {(isMobilePage ? !!domainConfig.demoUser : true) && (
        <LoginPageBtn
          loading={demoLoginLoader}
          onClick={handleDemoClick}
          label={langData?.["demo_login"] ?? "Login With Demo ID"}
          className={demoBtnClass}
        />
      )}
      {/* Mobile oauth sits below Sign Up link (rendered after LoginFooter) */}
      {!isMobilePage && domainConfig?.oauth_enabled && (
        <div className="flex flex-col items-center justify-center gap-1.5 w-full">
          <SocialAuth />
        </div>
      )}
    </div>
  );
};

// --- LoginFooter ---
interface LoginFooterProps {
  variant: LoginVariant;
  supportEmailId: string;
  handleSignUpClick: () => void;
  langData: Record<string, string> | undefined;
  domainConfig: {
    b2cEnabled?: boolean;
    oauth_enabled?: boolean;
    suppportContacts?: Array<{ contactType?: string; details?: string }>;
  };
}

const LoginFooter: React.FC<LoginFooterProps> = ({
  variant,
  supportEmailId,
  handleSignUpClick,
  langData,
  domainConfig,
}) => {
  if (variant === "header") return null;

  if (variant === "mobilePage") {
    // const whatsappLink = domainConfig?.suppportContacts?.find(
    //   (ct: { contactType?: string }) => ct.contactType === "REGISTRATION_WHATSAPP_LINK"
    // )?.details;

    return (
      <>
        {/* {domainConfig.b2cEnabled && (
          <div className="mt-2.5 flex w-full justify-center gap-1">
            <span className="text-xs text-black4">{langData?.["no_account"] ?? "Don't have an account? "}</span>
            <span onClick={handleSignUpClick} className="cursor-pointer text-xs font-bold text-black underline underline-offset-2">
              {langData?.["sign_up"] ?? "Sign Up"}
            </span>
          </div>
        )}
        {domainConfig?.oauth_enabled && (
          <div className="mt-2 flex w-full flex-col items-center justify-center gap-2">
            <div className="flex w-full items-center gap-2">
              <span className="h-px flex-1 bg-black/15" />
              <span className="text-[11px] text-black4">or continue with</span>
              <span className="h-px flex-1 bg-black/15" />
            </div>
            <SocialAuth />
          </div>
        )} */}
        {/* WhatsApp CTA temporarily hidden on login
        {whatsappLink && (
          <a
            href={whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="mt-1.5 flex h-9 w-full items-center justify-center gap-1.5 rounded-lg border border-gray6 bg-[rgba(255,255,255,.6)] px-2 text-[11px] font-medium text-black4"
          >
            <img src={whatsappIcon} alt="" className="h-4 w-4" />
            <span>{langData?.["whatsapp"] ?? "WhatsApp"}</span>
          </a>
        )}
        */}
      </>
    );
  }

  // standalone
  return (
    <>
      <div className="w-full flex justify-center">
        <a href={`mailto:${supportEmailId}`} className="text-white cursor-pointer text-xs uppercase">
          {supportEmailId}
        </a>
      </div>
      {domainConfig.b2cEnabled && (
        <div className="w-full flex justify-center">
          <div className="text-white">
            <span className="xl:hidden"> {langData?.["no_account"]}</span>
            <span onClick={handleSignUpClick} className="cursor-pointer text-[#ffff00] font-bold">
              {langData?.["sign_up"]}
            </span>
          </div>
        </div>
      )}
      <div className="border-t border-dashed border-white w-full p-1 flex justify-center relative">
        <div className="absolute left-0 w-[30px]">
          <div className="animate-slightLeftRightInfinite">
            <img alt="right-hand" className="w-8 object-cover" src={handIcon} />
          </div>
        </div>
        <div className="flex w-full justify-center">
          <a target="_blank" href="https://www.instagram.com/the.laser.official/" className="flex mx-4 items-center" rel="noreferrer">
            <img alt="instagram-icon" className="w-8 object-cover" src={instagramIcon} />
            <div className="text-white font-bold uppercase ml-1">{langData?.["instagram"] || "Instagram"}</div>
          </a>
          <a target="_blank" href="https://t.me/Laser247Tg" className="flex mx-4 items-center" rel="noreferrer">
            <img alt="telegram-icon" className="w-8 object-cover" src={telegramIcon} />
            <div className="text-white font-bold uppercase ml-1">{langData?.["telegram"]}</div>
          </a>
        </div>
      </div>
    </>
  );
};

// --- LoginSection (main) ---
interface LoginSectionProps {
  isHeader?: boolean;
  isMobileScreen?: boolean;
}

const LoginSection: React.FC<LoginSectionProps> = ({
  isMobileScreen = false,
  isHeader,
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { setSignUpModalOpen } = useSignUpModal();
  const { setResendEmailModalOpen } = useResendEmailModal();
  const { setForgotPasswordModalOpen } = useForgotPasswordModal();
  const { search, pathname } = useLocation();
  const authToken = new URLSearchParams(search).get("authToken");
  const { loggedIn } = useAppSelector((state) => state.auth);

  const variant: LoginVariant = isHeader ? "header" : isMobileScreen ? "mobilePage" : "standalone";

  const onSuccess = () => {
    const token = sessionStorage.getItem("jwt_token");
    if (token) {
      try {
        const claim = token.split(".")[1];
        const status = JSON.parse(window.atob(claim)).sts;
        if (status === 2) {
          navigate(ACCEPT_TERMS_ROUTE, { replace: true });
        } else if (status === 4) {
          navigate(RESET_PASSWORD_ROUTE, { replace: true });
        } else {
          dispatch(showToast({ type: "success", message: "Login Successfull" }));
        }
      } catch {
        // ignore
      }
    }
  };

  const loginReturn = useLogin({ navigate, onSuccess });
  const {
    formValues,
    handleChange,
    handleLoginSubmit,
    loading,
    onDemoLogin,
    domainConfig,
    langData,
    show2FAInput,
    setShow2FAInput,
    twoFactorCode,
    setTwoFactorCode,
    handle2FASubmit,
    is2FALoading,
    showReset2FA,
    setShowReset2FA,
    identifierValue,
    setIdentifierValue,
    resetIdentifierType,
    setResetIdentifierType,
    resetOtp,
    setResetOtp,
    resetOtpTimer,
    resetOtpEnterFields,
    resetLoading,
    isResetting,
    resetErrorMsg,
    generateResetOtp,
    resetTwoFactor,
    handleReset2FABack,
  } = loginReturn;
  const handle2FABack =
    typeof (loginReturn as unknown as { handle2FABack?: () => void }).handle2FABack === "function"
      ? (loginReturn as unknown as { handle2FABack: () => void }).handle2FABack
      : () => {
          setShow2FAInput(false);
          setTwoFactorCode("");
        };

  const [validationCode, setValidationCode] = useState(() =>
    String(Math.floor(1000 + Math.random() * 9000))
  );
  const [validationInput, setValidationInput] = useState("");
  const [demoLoginLoader, setDemoLoginLoader] = useState(false);

  const setSapToken = async (token: string) => {
    await getSapToken(token);
  };

  useEffect(() => {
    if (authToken) {
      setSapToken(authToken);
      const username = authToken?.split(".")?.[1];
      const uname = JSON.parse(window?.atob(username)).sub;
      const uid = JSON.parse(window?.atob(username)).uid;
      sessionStorage.setItem("username", uname);
      sessionStorage.setItem("aid", uid);
      sessionStorage.setItem("jwt_token", authToken);
      const claim = authToken.split(".")[1];
      sessionStorage.setItem("aid", JSON.parse(window.atob(claim)).aid);
      dispatch(loginSuccess(authToken));
      navigate("/home");
    }
  }, [authToken, dispatch, navigate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setValidationCode(String(Math.floor(1000 + Math.random() * 9000)));
    }, 20_000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (loggedIn) {
      setDemoLoginLoader(false);
      try {
        const claim = sessionStorage.getItem("jwt_token")?.split(".")[1];
        if (claim) {
          const status = JSON.parse(window.atob(claim)).sts;
          if (status === 2) navigate(ACCEPT_TERMS_ROUTE, { replace: true });
          else if (status === 4) navigate(RESET_PASSWORD_ROUTE, { replace: true });
        }
      } catch {
        // ignore
      }
    }
  }, [loggedIn, navigate]);

  const handleLogin = () => {
    if (validationInput.trim() !== validationCode) {
      dispatch(
        showToast({
          type: "error",
          message:
            langData?.["validation_code_mismatch"] ??
            "Validation code does not match. Please enter the displayed number.",
        })
      );
      return;
    }
    handleLoginSubmit({ preventDefault: () => {} } as React.FormEvent);
  };

  const handleForgotPassClick = () => setForgotPasswordModalOpen(true);
  const handleResendEmailClick = () => setResendEmailModalOpen(true);
  const handleSignUpClick = () => {
    if (isMobile) {
      navigate(REGISTER);
      return;
    }
    if (pathname === LOGIN_ROUTE) {
      navigate(HOME_ROUTE);
    }
    setSignUpModalOpen(true);
  };

  const handleEnterKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") handleLogin();
  };

  useEffect(() => {
    if (variant !== "header" || !show2FAInput) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") handle2FABack();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [variant, show2FAInput, handle2FABack]);

  const twoFAContentProps = {
    showReset2FA,
    setShowReset2FA,
    twoFactorCode,
    setTwoFactorCode,
    handle2FASubmit,
    handle2FABack,
    is2FALoading,
    identifierValue,
    setIdentifierValue,
    resetIdentifierType,
    setResetIdentifierType,
    resetOtp,
    setResetOtp,
    resetOtpTimer,
    resetOtpEnterFields,
    resetLoading,
    isResetting,
    resetErrorMsg,
    generateResetOtp,
    resetTwoFactor,
    handleReset2FABack,
    langData,
  };

  // Mobile: inline 2FA when on login page and 2FA required
  if (variant === "mobilePage" && show2FAInput) {
    return (
      <div className="flex flex-col w-full space-y-2 text-black3">
        <div className="w-full bg-white rounded-lg p-4 shadow border border-gray-200">
          <Login2FAContent {...twoFAContentProps} isInline={true} />
        </div>
      </div>
    );
  }

  const loginForm = (
    <div
      className={`items-center ${
        variant === "mobilePage"
          ? "flex w-full flex-col gap-1.5 space-y-0 text-black3 px-4"
          : "ml-1 hidden w-auto items-center gap-1.5 md:flex"
      }`}
    >
      <LoginFormFields
        variant={variant}
        formValues={formValues}
        handleChange={handleChange}
        validationCode={validationCode}
        validationInput={validationInput}
        setValidationInput={setValidationInput}
        handleEnterKeyPress={handleEnterKeyPress}
        handleForgotPassClick={handleForgotPassClick}
        handleResendEmailClick={handleResendEmailClick}
        handleSignUpClick={handleSignUpClick}
        langData={langData}
        domainConfig={domainConfig}
      />
      <LoginActionButtons
        variant={variant}
        handleLogin={handleLogin}
        onDemoLogin={onDemoLogin}
        handleSignUpClick={handleSignUpClick}
        loading={loading}
        demoLoginLoader={demoLoginLoader}
        setDemoLoginLoader={setDemoLoginLoader}
        langData={langData}
        domainConfig={domainConfig}
      />
      <LoginFooter
        variant={variant}
        supportEmailId={supportEmailId}
        handleSignUpClick={handleSignUpClick}
        langData={langData}
        domainConfig={domainConfig}
      />
    </div>
  );

  // Desktop: show login row and overlay 2FA popup when 2FA required
  if (variant === "header") {
    return (
      <>
        {loginForm}
        {show2FAInput && (
          <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 p-4"
            role="dialog"
            aria-modal="true"
            aria-label={langData?.["two_factor_auth"] ?? "Two-Factor Authentication"}
          >
            <div
              className="relative w-full max-w-md rounded-lg bg-black p-6 shadow-xl border border-goldenYellow"
              onClick={(e) => e.stopPropagation()}
            >
              <Login2FAContent {...twoFAContentProps} isInline={false} />
            </div>
          </div>
        )}
      </>
    );
  }

  return loginForm;
};

export default LoginSection;
